import React, { useState } from 'react'
import styles from '../styles/Register.module.scss'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'

import {
	Modal,
	Button,
	Form,
	Row,
	Col,
	Spinner,
	Alert
} from 'react-bootstrap'
import Select from 'react-select'
import dayjs from 'dayjs'

// May receive an id(ApplicantExperience)
export default function WorkExperienceModal ({ show, setShow, experiences, setExperiences, datas }): JSX.Element {
	// const { data } = datas
	const { t } = useTranslation()
	const [showEndDate, setShowEndDate] = useState(true)

	const initialInputs = {
		id: 0,
		jobTitle: '',
		companyName: '',
		occupation: '',
		startDate: '',
		endDate: '',
		description: ''
	}

	const months = [
		{ value: '01', label: t('Janurary') },
		{ value: '02', label: t('February') },
		{ value: '03', label: t('March') },
		{ value: '04', label: t('April') },
		{ value: '05', label: t('May') },
		{ value: '06', label: t('June') },
		{ value: '07', label: t('July') },
		{ value: '08', label: t('August') },
		{ value: '09', label: t('September') },
		{ value: '10', label: t('October') },
		{ value: '11', label: t('November') },
		{ value: '12', label: t('December') },
	]
	const years: {value: string, label: number}[] = []
	for (let i = dayjs().year(); i > 1961; i--) {
		years.push({ value: i.toString(), label: i })
	}

	const [inputs, setInputs] = useState(initialInputs)
	const [showAlert, setShowAlert] = useState(false)
	const [alertEndDate, setAlertEndDate] = useState(false)
	const [dateInputs, setDateInputs] = useState({
		startMonth: '',
		startYear: '',
		endMonth: '',
		endYear: '',
	})
	// console.log(inputs)
	
	let endYears: {value: string, label: number}[] = []
	if(dateInputs.startYear !== '') {
		const startYear = parseInt(dateInputs.startYear)
		for (let i = dayjs().year(); i >= startYear; i--) {
			endYears.push({ value: i.toString(), label: i})
		}
	} else {
		endYears = years
	}
  
	const submitData = () => {
		inputs.startDate = dateInputs.startYear + '-' + dateInputs.startMonth
		inputs.endDate = dateInputs.endMonth ? dateInputs.endYear + '-' + dateInputs.endMonth : ''
		inputs.id = uuidv4()
		const newArr = experiences.concat(inputs)
		setExperiences(newArr)
		setShow(false)
		setShowAlert(false)
		setAlertEndDate(false)
		setInputs(initialInputs)
		setShowEndDate(true)
	}

	const addExperience = async (event): Promise<void> => {
		event.preventDefault()
		event.stopPropagation()

		if(showEndDate) {
			if(dateInputs.endMonth === '' || dateInputs.endYear === '' || dateInputs.startMonth === '' || dateInputs.startYear === '') {
				setShowAlert(true)
				setAlertEndDate(true)
			} else {
				submitData()
			}
		} else if(dateInputs.startMonth === '' || dateInputs.startYear === '') {
			setShowAlert(true)
		} else {
			submitData()
		}
	}

	const validate = (event): void => {
		const name = event.target.name
		const str = event.target.value
		const temp = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		setInputs({ ...inputs, [name]: temp })
	}

	return (
		<Modal show={show} onHide={() => setShow(false)} size='lg'>
			<Form onSubmit={addExperience}>
				<Modal.Header closeButton className='text-center'>
					<h3 style={{ width: '100%' }}>{t('work_exp.add_work_experience')}</h3>
				</Modal.Header>
				<Modal.Body style={{ padding: '2rem' }}>
					{showAlert && (
						<Alert variant='danger'>
							{alertEndDate ? (
								<p className='m-0'>{t('work_exp.please_enter_end_date')}</p>
							) : (
								<p className='m-0'>{t('work_exp.please_enter_start_date')}</p>
							)}
						</Alert>
					)}
					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('work_exp.job_title')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									name='jobTitle'
									type='text'
									value={inputs.jobTitle}
									onChange={event => validate(event)}
									required
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('work_exp.company_name')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									name='companyName'
									type='text'
									value={inputs.companyName}
									onChange={event => validate(event)}
									required
								/>
							</Form.Group>
						</Col>
					</Row>
					{datas !== undefined ? (
						<Row className='mb-3'>
							<Col>
								<Form.Group>
									<Form.Label>
										{t('work_exp.occupation')}
										<span className={styles.mandatory}>*</span>
									</Form.Label>
									<Form.Select
										className={styles.formControl}
										as='select'
										value={inputs.occupation}
										onChange={event => {
											setInputs({
												...inputs,
												occupation: event.target.value
											})
										}}
										required
									>
										<option value='' disabled>{t('work_exp.select_occupation')}</option>
										{datas.Occupation.map((occupation, index) => (
											<option key={index} value={occupation.id}>
												{occupation.name}
											</option>
										))}
										<option value={9999}>{t('work_exp.others')}</option>
									</Form.Select>
								</Form.Group>
							</Col>
						</Row>
					) : (
						<Row className='mb-3'>
							<Col>
								<Spinner animation='border' />
							</Col>
						</Row>
					)}
					<Row className='mb-3'>
						<Col sm={12}>
							<Form.Group>
								<Form.Label>
									{t('work_exp.start_date')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Row>
									<Col sm={12} md={6}>
										<Select
											options={months}
											placeholder={t('sign_up.dob.month')}
											className={styles.formControl}
											onChange={value => {
												setDateInputs({ ...dateInputs, startMonth: value?.value as string})
											}}
											value={months.find(month => month.value === dateInputs.startMonth)}
											styles={{
												control: (provided) => ({
													...provided,
													borderRadius: '12px',
													marginBottom: '0.5rem'
												})
											}}
										/>
									</Col>
									<Col sm={12} md={6}>
										<Select
											options={years}
											placeholder={t('sign_up.dob.year')}
											className={styles.formControl}
											onChange={value => {
												setDateInputs({ ...dateInputs, startYear: value?.value as string })
											}}
											value={years.find(year => year.value === dateInputs.startYear)}
											styles={{
												control: (provided) => ({
													...provided,
													borderRadius: '12px',
													marginBottom: '0.5rem'
												})
											}}
										/>
									</Col>
								</Row>
								<Form.Check
									id='showEndDate'
									type='checkbox'
									label={t('work_exp.currently_working')}
									checked={!showEndDate}
									onChange={() => {
										setShowEndDate(!showEndDate)
										setInputs({
											...inputs,
											endDate: ''
										})
									}}
								/>
							</Form.Group>
						</Col>
					</Row>

					{showEndDate && (
						<Row className='mb-3'>
							<Col sm={12}>
								<Form.Group>
									<Form.Label>
										{t('work_exp.end_date')}
										<span className={styles.mandatory}>*</span>
									</Form.Label>
									<Row>
										<Col sm={12} md={6}>
											<Select
												options={months}
												placeholder={t('sign_up.dob.month')}
												className={styles.formControl}
												onChange={value => {
													setDateInputs({ ...dateInputs, endMonth: value?.value as string })
												}}
												value={months.find(month => month.value === dateInputs.endMonth)}
												styles={{
													control: (provided) => ({
														...provided,
														borderRadius: '12px',
														marginBottom: '0.5rem'
													})
												}}
											/>
										</Col>
										<Col sm={12} md={6}>
											<Select
												options={endYears}
												placeholder={t('sign_up.dob.year')}
												className={styles.formControl}
												onChange={value => {
													setDateInputs({ ...dateInputs, endYear: value?.value as string })
												}}
												value={endYears.find(year => year.value === dateInputs.endYear)}
												styles={{
													control: (provided) => ({
														...provided,
														borderRadius: '12px',
														marginBottom: '0.5rem'
													})
												}}
											/>
										</Col>
									</Row>
								</Form.Group>
							</Col>
						</Row>
					)}
					
					<Row className='mb-3'>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('work_exp.description')}
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									name='description'
									as='textarea'
									rows={3}
									value={inputs.description}
									onChange={event => validate(event)}
								/>
							</Form.Group>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant='primary'
						// onClick={() => setShow(false)}
						type='submit'
						className='text-white'
					>
						{t('work_exp.save')}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	)
}
